/* eslint-disable react/no-unused-state */
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable no-underscore-dangle */

import React, { Component } from 'react';
import {
  getDateForCalendar, getDateForFilter, getYesterday,
  getDateFromString, getDateForIntervalFilter, getTodaysDate, convertToDATEFormat,
} from '../utils/common';
import SVGComponent from './SVG/SVGComponent';
import { CALENDAR_FIELDS, MANIPULATIONS, SVG_ICONS } from '../constants';
import NewCalendar from './NewCalendar';
import validateFields from '../utils/validation';

const yesterday = getDateForCalendar(getYesterday());
const today = getDateForCalendar(new Date());
const ACTIVE_FILTER = [
  '30#minutes ago', '5#hours ago', '24#hours ago', `Today#${today}`, `Yesterday#${yesterday}`,
];

export default class IntervalDates extends Component {
  constructor(props) {
    super(props);
    /**
     * @member {object}
     * @description Properties has _ prefix to avoid matching filter keys
     * with component properties.
     * @property {boolean} isOpen
     * @property {string} _fromDate
     * @property {string} _toDate
     * @property {string} _fromTime
     * @property {string} _toTime
     * @property {object} filter
     * @property {number} activeFilter
     * @property {boolean} isCustomOpen
     */
    const fromDate = props.filter[props.fields[0]];
    const toDate = props.filter[props.fields[1]];
    this.state = this.getInintalState(fromDate, toDate, props);
  }

  /**
   * Update state on clear filter
   *
   * @param {object} prevProps
   * @returns {void}
   */
  componentDidUpdate(prevProps) {
    if ((this.props.filter[this.props.fields[0]] !== prevProps.filter[prevProps.fields[0]])
      || (this.props.filter[this.props.fields[1]] !== prevProps.filter[prevProps.fields[1]])) {
      const fromDate = this.props.filter[this.props.fields[0]];
      const toDate = this.props.filter[this.props.fields[1]];
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState(this.getInintalState(fromDate, toDate, this.props));
    }

    if (this.props.selectedTimezone !== prevProps.selectedTimezone && prevProps.selectedTimezone !== '') {
      this.setState({
        timezoneChanged: true,
      });
    }
  }

  /**
   * Calculate state for parsed interval date
   *
   * @function
   * @param {string} from
   * @param {string} to
   * @param {object} props
   * @returns {object}
   */
  getInintalState = (from, to, props) => {
    let splitChar = ' ';
    if (from?.includes('T')) {
      splitChar = 'T';
    }
    const fromDate = from ? from.split(splitChar) : null;
    const toDate = to ? to.split(splitChar) : null;

    return ({
      isOpen: false,
      _fromDate: fromDate ? new Date(fromDate[0]) : '',
      _fromTime: fromDate ? fromDate[1] : '',
      _toDate: toDate ? new Date(toDate[0]) : '',
      _toTime: toDate ? toDate[1] : '',
      filter: {
        _fromTime: fromDate ? fromDate[1] : '',
        _toTime: toDate ? toDate[1] : '',
        [props.fields[0]]: fromDate ? getDateForFilter(new Date(fromDate[0])) : '',
        [props.fields[1]]: toDate ? getDateForFilter(new Date(toDate[0])) : '',
      },
      activeFilter: 3,
      isCustomOpen: false,
      errorMgs: {},
      showCalendar: null,
      timezoneChanged: false,
    });
  };

  /**
   * Toggle calendar
   *
   * @function
   * @returns {void}
   */
  toggleCalendarPopup = () => {
    this.setState({
      isOpen: !this.state.isOpen,
      isCustomOpen: false,
      errorMgs: {},
    });
  };

  /**
   * Reset Dates Filter
   *
   * @function
   * @returns {void}
   */
  resetDates = () => {
    const fromDate = this.props.defaultFilter[this.props.fields[0]];
    const toDate = this.props.defaultFilter[this.props.fields[1]];

    this.setState(this.getInintalState(fromDate, toDate, this.props));
    this.apply(MANIPULATIONS.RESET_DATE_AND_TIME);
  };

  /**
   * Discard changes
   *
   * @function
   * @returns {void}
   */
  cancel = () => {
    this.setState({
      isOpen: false,
      filter: {
        _fromTime: this.state._fromTime,
        _toTime: this.state._toTime,
        [this.props.fields[0]]: getTodaysDate(this.props.selectedTimezone),
        [this.props.fields[1]]: getTodaysDate(this.props.selectedTimezone),
      },
      activeFilter: 3,
      isCustomOpen: false,
      errorMgs: {},
    });
  };

  /**
   * Adjust Date and Time According to Calendar Popup
   *
   * @function
   * @param {string} type
   */
  adjustDateAndTimeAccordingToCalendarPopup = (type) => {
    const filter = ACTIVE_FILTER[this.state.activeFilter]?.split('#');
    let from = '';
    let to = '';
    let date;
    if (filter[1] === 'minutes ago') {
      const minutes = filter[0];
      date = new Date();
      to = getDateForIntervalFilter(date);
      date.setMinutes(date.getMinutes() - minutes);
      from = getDateForIntervalFilter(date);
    } else if (filter[1] === 'hours ago') {
      const hours = filter[0];
      date = new Date();
      to = getDateForIntervalFilter(date);
      date.setHours(date.getHours() - hours);
      from = getDateForIntervalFilter(date);
    } else {
      date = getDateFromString(filter[1]);
      from = `${date} 00:00`;
      to = `${date} 23:59`;
    }

    if (type === MANIPULATIONS.RESET_DATE_AND_TIME) {
      from = '';
      to = '';
    }

    this.props.changeFilter(from, this.props.fields[0]);
    this.props.changeFilter(to, this.props.fields[1]);
    this.setState(this.getInintalState(from, to, this.props));
  };

  /**
   * Adjust Date and Time According to Custom Option
   *
   * @function
   */
  adjustDateAndTimeAccordingToCustomOption = () => {
    const fromDate = this.state.filter[this.props.fields[0]];
    this.props.changeFilter(fromDate ? `${fromDate} ${this.state.filter._fromTime}` : '', this.props.fields[0]);
    const toDate = this.state.filter[this.props.fields[1]];
    this.props.changeFilter(toDate ? `${toDate} ${this.state.filter._toTime}` : '', this.props.fields[1]);

    const validationParams = [{
      label: 'To date',
      fieldName: 'toDate',
      value: `${toDate} ${this.state.filter._toTime}`,
      rules: ['mandatory', 'greaterThan'],
      comparatorValue: `${fromDate} ${this.state.filter._fromTime}`,
    }];

    validateFields(validationParams)
      .then(() => {
        this.setState({
          isOpen: false,
          _fromDate: fromDate ? convertToDATEFormat(fromDate) : '',
          _toDate: toDate ? convertToDATEFormat(toDate) : '',
          _fromTime: this.state.filter._fromTime,
          _toTime: this.state.filter._toTime,
          activeFilter: this.state.activeFilter,
          isCustomOpen: false,
          timezoneChanged: false,
        });
      }).catch((errorMgs) => {
        this.setState({
          errorMgs,
        });
      });
  };

  /**
   * Change dates
   *
   * @function
   * @param {string} type
   * @returns {void}
   */
  apply = (type) => {
    if (this.state.isCustomOpen) {
      this.adjustDateAndTimeAccordingToCustomOption();
    } else {
      this.adjustDateAndTimeAccordingToCalendarPopup(type);
    }
  };

  /**
   * Change quick filter
   *
   * @function
   * @param {number} index
   * @returns {void}
   */
  changeFilter = (index) => {
    this.setState({
      activeFilter: index,
    });
  };

  /**
   * Change custom date filter
   *
   * @function
   * @param {string} fieldValue
   * @param {string} field
   * @returns {void}
   */
  // eslint-disable-next-line react/no-unused-class-component-methods
  changeFilterDate = (fieldValue, field) => {
    const tempFilter = this.state.filter;
    tempFilter[field] = fieldValue;
    this.setState({
      filter: tempFilter,
      errorMgs: {},
    });
  };

  /**
   * Toggle custom filters
   *
   * @function
   * @returns {void}
   */
  toggleCustomFilter = () => {
    if (!this.state.isCustomOpen
      && !this.state.filter?._fromTime
      && !this.state.filter?._toTime) {
      const todayDate = getTodaysDate(this.props.selectedTimezone);

      const updatedFilters = { ...this.state.filter };
      updatedFilters._fromTime = '00:00';
      updatedFilters._toTime = '23:59';

      if (this.props.dateFilterFields) {
        this.props.dateFilterFields.forEach((field) => {
          updatedFilters[field] = todayDate;
        });
      }
      this.setState({
        isCustomOpen: !this.state.isCustomOpen,
        filter: updatedFilters,
      });
    } else {
      this.setState({
        isCustomOpen: !this.state.isCustomOpen,
      });
    }
  };

  handleTimeChange = (e) => {
    const updatedFilters = { ...this.state.filter };
    updatedFilters[e.target.name] = e.target.value;
    this.setState({
      filter: updatedFilters,
    });
  };

  handleDateChange = (dateString) => {
    const newDate = getDateForIntervalFilter(dateString)?.split(' ')?.[0];

    const updatedFilters = { ...this.state.filter };
    if (this.state.showCalendar === CALENDAR_FIELDS.FROM) {
      updatedFilters.filterStartDate = newDate;
    } else {
      updatedFilters.filterEndDate = newDate;
    }
    this.setState({
      filter: updatedFilters,
    });
  };

  toggleCalendar = (calendarId) => {
    const calendarState = this.state.showCalendar === calendarId ? null : calendarId;
    this.setState({
      showCalendar: calendarState,
    });
  };

  /**
   * Render
   *
   * @returns {view}
   */
  render() {
    const fromDate = getDateForCalendar(this.state._fromDate);
    const toDate = getDateForCalendar(this.state._toDate);

    return (

      <div
        className={`filter__field-input hasCalendar ${this.state.isOpen ? 'open' : ''}`}
      >
        <div className="mask" />
        <div className="filter__field-input-toggle" onClick={this.toggleCalendarPopup}>
          <span className="filter__field-input-date">
            <div>
              From:
              <span className="m-l-10">
                {!this.state.timezoneChanged
                  ? (
                    <>
                      <span>{fromDate || '-'}</span>
                      <span className="m-l-10">{this.state._fromTime}</span>
                    </>
                  ) : null}
              </span>
            </div>
            <div>
              To:
              <span className="m-l-20">
                {!this.state.timezoneChanged
                  ? (
                    <>
                      <span>{toDate || '-'}</span>
                      <span className="m-l-10">{this.state._toTime}</span>
                    </>
                  ) : null}
              </span>
            </div>
          </span>
          <span className="calendar-icon" />
        </div>
        <div className="calendar__popup">
          <div className="calendar__popup-heading-wrap">
            <div className="calendar__popup-heading">
              <h3>Select time range</h3>
              <SVGComponent
                className="icon-xxs calendar__popup-close"
                src={`${SVG_ICONS.utility}#close-sm`}
                onClick={this.toggleCalendarPopup}
              />
            </div>
          </div>
          <div className="d-flex">
            <div>
              <div className="calendar__popup-option">
                {
                  ACTIVE_FILTER.map((f, i) => {
                    const filter = f.split('#');
                    return (
                      <div
                        key={f}
                        className={`calendar__popup-row ${this.state.activeFilter === i
                          && !this.state.isCustomOpen ? 'active' : ''}`}
                        onClick={this.changeFilter.bind(this, i)}
                      >
                        <div className="mr-4 w-30">{filter[0]}</div>
                        <span>{filter[1]}</span>
                      </div>
                    );
                  })
                }
              </div>
              <div
                className="calendar__popup-row mt-3 calendar-trigger"
                onClick={this.toggleCustomFilter}
              >
                <span>Enter custom range</span>
              </div>
            </div>
            <div className={`calendar__popup-custom-field ${this.state.isCustomOpen ? 'open' : ''}`}>
              <div className="mb-2">From</div>
              <div className={`calendar__popup-input-style has-calendar mt-2 
                  ${this.state.showCalendar === CALENDAR_FIELDS.FROM ? 'is-open' : ''}`}
              >
                <div className="calendar__wrapper d-flex align-items-center">
                  <div className="calendar__input-date">{this.state.filter?.filterStartDate}</div>
                </div>
                <span className="calendar-icon" onClick={this.toggleCalendar.bind(this, CALENDAR_FIELDS.FROM)} />

                <NewCalendar
                  closeCalendar={this.toggleCalendar.bind(this, null)}
                  filter={this.props.filter}
                  field={this.props.fields[0]}
                  handleDateChange={this.handleDateChange}
                />

              </div>
              <input
                type="time"
                className="calendar__popup-input-style mt-2"
                value={this.state.filter?._fromTime}
                onChange={this.handleTimeChange}
                name="_fromTime"
              />
              <div className="mb-2 mt-2">To</div>
              <div className={`calendar__popup-input-style has-calendar
                  ${this.state.showCalendar === CALENDAR_FIELDS.TO ? 'is-open' : ''}`}
              >
                <div className="calendar__wrapper d-flex align-items-center">
                  <div className="calendar__input-date">{this.state.filter?.filterEndDate}</div>
                </div>
                <span className="calendar-icon" onClick={this.toggleCalendar.bind(this, CALENDAR_FIELDS.TO)} />

                <NewCalendar
                  closeCalendar={this.toggleCalendar.bind(this, null)}
                  filter={this.props.filter}
                  field={this.props.fields[1]}
                  handleDateChange={this.handleDateChange}
                />

              </div>

              {this.state?.errorMgs?.toDate && (
                <div className="error-txt mt-1">{this.state.errorMgs.toDate}</div>
              )}

              <input
                type="time"
                className="calendar__popup-input-style mt-2"
                value={this.state.filter?._toTime}
                onChange={this.handleTimeChange}
                name="_toTime"
              />
            </div>
          </div>
          <div className="calendar__popup-button-wrap">
            <div className="calendar__popup-button">
              <button
                type="button"
                className="btn btn-secondary mr-auto"
                onClick={this.resetDates}
              >
                Reset
              </button>
              {' '}
              <button
                type="button"
                className="btn btn-secondary ml-4"
                onClick={this.cancel}
              >
                Cancel
              </button>
              {' '}
              <button
                type="button"
                className="btn btn-primary ml-1"
                onClick={this.apply}
              >
                Apply
              </button>
            </div>
          </div>
        </div>

      </div>
    );
  }
}
